import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { SmsStatusDTO } from '../../../api/sms-status-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveSmsStatusModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedSmsStatus?: SmsStatusDTO;
    onHide: () => void;
    onSave: (values: SmsStatusDTO) => void;
    onDelete?: (smsStatus: SmsStatusDTO) => void;
}

export function SaveSmsStatusModal({
    show,
    allowEdit,
    selectedSmsStatus,
    onHide,
    onSave,
    onDelete,
}: SaveSmsStatusModalProps) {
    const SmsStatusSchema = yup.object().shape({
        id: yup.string().required(' '),
        title: yup.string().required(' '),
    });

    const defaultValues: SmsStatusDTO = {
        id: selectedSmsStatus ? selectedSmsStatus.id : '',
        title: selectedSmsStatus ? selectedSmsStatus.title : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={SmsStatusSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedSmsStatus ? 'edit-sms-status' : 'new-sms-status'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedSmsStatus && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedSmsStatus)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="id"
                                name="id"
                                readOnly={!allowEdit || !!selectedSmsStatus}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="title"
                                name="title"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
